<template>
  <div class="flex flex-row items-center justify-start">
    <nuxt-icon
      class="text-24 sm:text-[27px] mr-8"
      name="check-circle-green"
      filled
      aria-hidden="true"
    />
    <div class="flex flex-col items-start">
      <p class="font-medium">{{ label }}</p>
      <p v-if="subLabel">{{ subLabel }}</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
type Props = {
  label: string;
  subLabel?: string;
};

withDefaults(defineProps<Props>(), {
  subLabel: '',
});
</script>

<style lang="scss" scoped></style>
